(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-pm-cookie-preferences]');
  if (!button) return;
  const status = button.parentElement.querySelector('[data-pm-cookie-status]');
  status.textContent = '';
  button.disabled = true;
  try {
    if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') throw new Error('unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    status.textContent = status.dataset.error;
  } finally {
    button.disabled = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const init = form => {
    if(form.dataset.pmReady)return;
    form.dataset.pmReady='true';
    const rows=Array.from(form.querySelectorAll('[data-design]'));
    const checkout=form.querySelector('[name="checkout"]');
    const message=form.querySelector('[data-cart-repair]');
    let mismatch=false;
    const designs=[...new Set(rows.map(r=>r.dataset.design).filter(Boolean))];
    for(const design of designs){
      const parents=rows.filter(r=>r.dataset.print==='false' && r.dataset.design===design);
      const children=rows.filter(r=>r.dataset.print==='true' && r.dataset.design===design);
      const input=row=>row.querySelector('[name="updates[]"]');
      const sync=()=>{
        let left=parents.reduce((sum,r)=>sum+Math.max(0,Number(input(r).value)||0),0);
        children.forEach((child,index)=>{const target=index===children.length-1?left:Math.min(left,Math.max(0,Number(input(child).value)||0));if(Number(input(child).value)!==target){input(child).value=target;mismatch=true;}left-=target;});
      };
      sync();parents.forEach(parent=>input(parent).addEventListener('input',sync));
    }
    if(mismatch){checkout.disabled=true;message.hidden=false;}
  };
  document.querySelectorAll('[data-pm-cart]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-pm-cart]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-pm-product]').forEach(root => {
      if (root.dataset.variantReady) return;
      const variantSelect = root.querySelector('[name="id"]');
      if (!variantSelect) return;
      root.dataset.variantReady = 'true';
      const selectors = [...root.querySelectorAll('.product-option-selector')];
      const price = root.querySelector('[data-variant-price]');
      const form = variantSelect.form;
      const button = form.querySelector('[type="submit"]');
      const variants = [...variantSelect.options].map(option => ({
        id: option.value,
        options: JSON.parse(option.dataset.options),
        price: option.dataset.price,
        available: option.dataset.available === 'true'
      }));
      const syncOptions = variant => {
        if (variant) selectors.forEach((select, index) => { select.value = variant.options[index]; });
      };
      const update = (updateUrl = false) => {
        const values = selectors.map(select => select.value);
        const variant = selectors.length
          ? variants.find(item => item.options.length === values.length && item.options.every((value, index) => value === values[index]))
          : variants.find(item => item.id === variantSelect.value);
        variantSelect.value = variant ? variant.id : '';
        variantSelect.disabled = !variant;
        price.textContent = variant ? variant.price : root.dataset.unavailable;
        button.disabled = !variant || !variant.available;
        button.textContent = !variant ? root.dataset.unavailable : variant.available ? root.dataset.add : root.dataset.soldOut;
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url);
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      };
      syncOptions(variants.find(item => item.id === variantSelect.value));
      selectors.forEach(select => select.addEventListener('change', () => update(true)));
      form.addEventListener('submit', event => {
        const variant = variants.find(item => item.id === variantSelect.value);
        if (!variant || !variant.available) event.preventDefault();
      });
      window.addEventListener('popstate', () => {
        const id = new URL(window.location.href).searchParams.get('variant');
        syncOptions(variants.find(item => item.id === id));
        update();
      });
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-printed-bag"]) return;
  try {
    
document.querySelectorAll('[data-pm-bag]').forEach(root=>{
 const form=root.querySelector('form'), file=root.querySelector('input[type=file]'), art=root.querySelector('[data-art]'), size=root.querySelector('[data-size]'), y=root.querySelector('[data-y]'), error=root.querySelector('[data-error]');let objectURL=null,ready=false;
 const variantSelect=root.querySelector('[name="id"]');
 const updatePrices=()=>{const selected=variantSelect.selectedOptions[0];if(!selected)return;root.querySelector('[data-bag-price]').textContent=selected.dataset.price;root.querySelector('[data-bag-offer]').textContent=selected.dataset.offer;};
 variantSelect.addEventListener('change',updatePrices);updatePrices();
 const position=()=>{art.style.width=size.value+'%';art.style.top=y.value+'%';root.querySelector('[data-placement]').value='Breedte '+size.value+'%, bovenkant '+y.value+'% van voorbeeld; horizontaal gecentreerd';};
 size.addEventListener('input',position);y.addEventListener('input',position);
 file.addEventListener('change',()=>{ready=false;art.hidden=true;file.setCustomValidity('');error.textContent='';if(objectURL)URL.revokeObjectURL(objectURL);const f=file.files[0];if(!f)return;if(!['image/png','image/jpeg','image/webp'].includes(f.type)||f.size>10*1024*1024){file.setCustomValidity(error.dataset.message);error.textContent=error.dataset.message;return;}objectURL=URL.createObjectURL(f);art.onload=()=>{ready=true;art.hidden=false;};art.onerror=()=>{ready=false;file.setCustomValidity(error.dataset.message);error.textContent=error.dataset.message;};art.src=objectURL;});
 form.addEventListener('submit',e=>{if(!ready){e.preventDefault();error.textContent=error.dataset.message;return;}const b=form.querySelector('button');b.disabled=true;b.textContent=b.dataset.busy;});
 window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
});

  } catch(e) { console.error(e); }
})();
})();
